import {createActionTypes, createActionCreators} from 'utils/reduxUtils';

const typesArray = [
    'API_KEYS_LIST_ON_APIKEY_CLICK',
];

export const ActionTypes = createActionTypes(typesArray);
export const Actions = createActionCreators(typesArray);
